
import {designerFormatName} from './product';



export function displayPhone(phoneString) {
	let digitString = stringToDigits(phoneString);
	return (digitString.slice(0, 3) + '.' + digitString.slice(3, 6) + '.' + digitString.slice(6, 10));
}

export function displayPhoneInput(phoneString) {
	let digitString = stringToDigits(phoneString);
	if(digitString.length <= 3) {
		return digitString;
	} else if(digitString.length <= 6) {
		return (digitString.slice(0, 3) + '-' + digitString.slice(3, 6));
	} else {
		return (digitString.slice(0, 3) + '-' + digitString.slice(3, 6) + '-' + digitString.slice(6, 10));
	}
}

export function displayDate(dateString) {
	if(dateString.trim() == '') {
		return '';
	}
	let digitString = stringToDigits(dateString);
	return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8));
}

export function displayDateFromDate(jsDate) {
	// if(jsDate.trim() == '') {
		// return '';
	// }

	// return jsDate;
	// console.log(jsDate);
	

	// let digitString = stringToDigits(dateString);
	// return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8));

	let dd = jsDate.getDate();
	let mm = jsDate.getMonth() + 1;
	let y = jsDate.getFullYear();

	return mm + '/' + dd + '/' + y;

	// return 'jsDate';
}

export function displayDateInput(dateString) {
	let digitString = stringToDigits(dateString);
	if(digitString.length < 2) {
		return digitString;
	} else if(digitString.length < 3) {
		return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4));
	} else {
		return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4) + '-' + digitString.slice(4, 8));
	}
}

export function displayDateNoYear(dateString) {
	if(dateString.trim() == '') {
		return '';
	}
	let digitString = stringToDigits(dateString);
	return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4));
}

export function displayDateNoYearInput(dateString) {
	let digitString = stringToDigits(dateString);
	if(digitString.length < 2) {
		return digitString;
	} else {
		return (digitString.slice(0, 2) + '-' + digitString.slice(2, 4));
	} 
}

export function displayDateFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
}

export function displayVerboseDateFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	return (monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear());
}

export function displayTimeFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let hour = d.getHours();
	let suffix = ' AM';
	if(hour > 12) {
		hour -= 12;
		suffix = ' PM';
	}
	if(hour === 0) {
		hour = 12;
	}
	let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();

	return (hour + ':' + minutes + suffix);
}

export function stringToDigits(testString) {
	return testString.replace( /[^0-9]/g, '');
}

export function stringStripNonCaps(testString) {
	return testString.replace( /[^A-Z]/g, '');
}

export function formatDropdownData(dataArray, displayKey, valueKey, nullLabel = 'Select') {
	let returnArray = [
		{
			display: nullLabel,
			value: '',
		},
	];
	for(let i = 0; i < dataArray.length; i++) {
		returnArray.push({
			display: dataArray[i][displayKey],
			value: dataArray[i][valueKey],
		});
	}
	return returnArray;
}

export function diamondImgUrl(diamond) {
	return '';
}

export function diamondTitle(diamond) {
	return diamond.shape + ' ' + parseFloat(diamond.caratWeight).toFixed(2) + ' ' + diamond.color + ' ' + diamond.clarity;
}

export function diamondPrice(diamond) {
	return 'price';
}

export function formatQuerystring(queryObj) {
    let pairsArray = [];

    for (const key in queryObj) {
      pairsArray.push(key + '=' + queryObj[key]);
    }
    return pairsArray.join('&');
}

export function titleCase(str) {

	if(!str) {
		return '';
	}

	let splitStr = str.toLowerCase().split(' ');
	for (let i = 0; i < splitStr.length; i++) {
		if(i === 0 || splitStr[i].length > 3) {
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
		}
	}
	return splitStr.join(' ');
}

export function compareValue(str = '') {

	if(!str) {
		return "None";
	} else {
		return titleCase(str);
	}
}

export function formatDbDate(dbdate = '') {
	if(dbdate.trim() == '') {
		return '';
	}
	let splitDate = dbdate.toLowerCase().split('-');
	return (splitDate[1] + '-' + splitDate[2] + '-' + splitDate[0]);
}

export function formatDateForDb(dateString = '') {
	if(dateString.trim() == '') {
		return '';
	}
	let digitString = stringToDigits(dateString);
	return (digitString.slice(4, 8) + '-' + digitString.slice(0, 2) + '-' + digitString.slice(2, 4));
}

export function getFormattedMetalType(metalType) {
	if(!metalType) {
		return '';
	}
	switch(metalType) {
		case 'WG14':
			return '14k white gold';
		case 'YG14':
			return '14k yellow gold';
		case 'RG14':
			return '14k rose gold';
		case 'GG14':
			return '14k Gray gold';
		case 'WG18':
			return '18k white gold';
		case 'YG18':
			return '18k yellow gold';
		case 'RG18':
			return '18k rose gold';
		case 'GG18':
			return '18k gray gold';
		case 'TT':
			return 'Two-tone';
		case 'PLAT':
			return 'Platinum';
		case 'STEEL':
			return 'Stainless Steel';
		case 'SS':
			return 'Sterling Silver';
		case '18/PT':
			return '18K Platinum';
		case '14/PT':
			return '14K Platinum';
		case 'PALL':
			return 'Palladium';
		case 'TITAN':
			return 'Titanium';
		case 'TUNG':
			return 'Tungsten';
		case 'ELY':
			return 'Elysium';
		case 'COBLT':
			return 'Cobalt';
		case 'TANT':
			return 'Tantalum';
		case 'TRI':
			return 'Tri-color';
		case 'WG/TA':
			return 'White Gold/Tantalum';
		case 'RG/TA':
			return 'Rose Gold/Tantalum';
		case 'YG/TA':
			return 'Yellow Gold/Tantalum';
		case 'TA/TI':
			return 'Tantalum/Titanium';
		case 'WG/PT':
			return 'White Gold/Platinum';
		case 'RG/PT':
			return 'Rose Gold/Platinum';
		case 'YG/PT':
			return 'Yellow Gold/Platinum';
		case 'WG/TI':
			return 'White Gold/Titanium';
		case 'YG/TI':
			return 'Yellow Gold/Titanium';
		case 'RG/TI':
			return 'Rose Gold/Titanium';
		case 'RG/PD':
			return 'Rose Gold/Palladium';
		case 'NOMETAL':
			return 'No metal';
	}
	return metalType;
}


export function settingCartDesc(setting, metalType, ringSize) {

	console.log(setting);

	let settingDesc = '';

	if(setting.vendor && setting.vendor.name && setting.vendor.item_number) {
		settingDesc += (designerFormatName(setting.vendor.name) + ' / ' + setting.vendor.item_number + '<br />');
	}
	settingDesc += ('<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />');
	settingDesc += ('<B>Carat weight</B>: ' + setting.ttw_dia + '<br />');
	settingDesc += ('<B>Finger size</B>: ' + ringSize);

	return settingDesc;
}

export function diamondCartDesc(diamond) {

	let diamondDesc = '';

	diamondDesc += '<B>Stock number</B>: ' + diamond.stockNo + '<br />';
	diamondDesc += '<B>Diamond Shape</B>: ' + diamond.shape + '<br />';
	diamondDesc += '<B>Carat weight</B>: ' + parseFloat(diamond.caratWeight).toFixed(2) + '<br />';
	diamondDesc += '<B>Color</B>: ' + diamond.color + '<br />';
	diamondDesc += '<B>Clarity</B>: ' + diamond.clarity + '<br />';
	diamondDesc += '<B>Diamond Certificate</B>: GIA';

	return diamondDesc;
}

export function mensBandDescription(prod, metalType, ringSize) {

	// Designer Name / Vendor ID
	// Carat weight:
	// Finger size:

	let bandDesc = '';

	if(prod.vendor && prod.vendor.name && prod.vendor.item_number) {
		bandDesc += (designerFormatName(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />');
	}

	bandDesc += ('<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />');
	bandDesc += ('<B>Carat weight</B>: ' + prod.ttw_dia + '<br />');
	bandDesc += ('<B>Finger size</B>: ' + ringSize);

	return bandDesc;
}

export function womensBandDescription(prod, metalType, ringSize) {

	// Designer Name / Vendor ID
	// Metal type: (INTERNAL NOTE FOR WEST: should be written out as 14k white gold, yellow gold, rose gold / 18k white gold, yellow gold, rose gold / platinum)
	// Carat weight:
	// Finger size:

	let bandDesc = '';

	if(prod.vendor && prod.vendor.name && prod.vendor.item_number) {
		bandDesc += (designerFormatName(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />');
	}

	bandDesc += ('<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />');
	bandDesc += ('<B>Carat weight</B>: ' + prod.ttw_dia + '<br />');
	bandDesc += ('<B>Finger size</B>: ' + ringSize);

	return bandDesc;
}


export function fashionCartDesc(prod, metalType) {

	let fashionDesc = '';

	if(prod.vendor && prod.vendor.name && prod.vendor.item_number) {
		fashionDesc += (designerFormatName(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />');
	}

	fashionDesc += ('<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />');
	fashionDesc += ('<B>Carat weight</B>: ' + prod.ttw_dia);

	return fashionDesc;
}

export function fashionRingCartDesc(prod, metalType, ringSize) {

	let fashionDesc = '';

	if(prod.vendor && prod.vendor.name && prod.vendor.item_number) {
		fashionDesc += (designerFormatName(prod.vendor.name) + ' / ' + prod.vendor.item_number + '<br />');
	}

	fashionDesc += ('<B>Metal type</B>: ' + getFormattedMetalType(metalType) + '<br />');
	fashionDesc += ('<B>Carat weight</B>: ' + prod.ttw_dia + '<br />');
	fashionDesc += ('<B>Finger size</B>: ' + ringSize);

	return fashionDesc;
}



export function bandCartDesc(band, metalType = null, ringSize) {

	let bandDesc = '';

	if(band.vendor && band.vendor.name) {
		bandDesc += designerFormatName(band.vendor.name);
	}
	if(band.vendor.item_number) {
		bandDesc += (' / ' + band.vendor.item_number);
	}
	bandDesc += '<br />';

	if(metalType) {
		bandDesc += '<B>Metal type</B>: ' + metalType + '<br />';
	}

	bandDesc += '<B>Carat weight</B>: ' + band.ttw_dia + '<br />';
	bandDesc += '<B>Finger size</B>: ' + ringSize + '<br />';

	return bandDesc;
}

export function getLocationNameById(locNum) {

	if(!locNum) {
		return '';
	}

	switch (locNum) {
    case 1:
      return 'Charlotte';
    case 2:
      return 'Headquarters';
    case 3:
      return 'Birmingham';
    case 4:
      return 'Raleigh';
    case 5:
      return 'Austin';
    case 6:
      return 'Richmond';
    case 7:
      return 'Charleston';
    case 8:
      return 'Oklahoma City';
    case 9:
      return 'Virginia Beach';
    case 10:
      return 'San Antonio';
    case 11:
      return 'Dallas';
    case 12:
      return 'Indianapolis';
    case 13:
      return 'St. Louis';
    case 14:
      return 'Jacksonville';
    case 15:
      return 'Salt Lake City';
    case 16:
      return 'Columbus';
    case 17:
      return 'Cleveland';
    case 18:
      return 'Frisco';
    case 19:
      return 'Kansas City';
    case 20:
      return 'New Orleans';
    case 21:
      return 'Boca Raton';
    default:
      return '';
  }
}

export function getIdByLocation(locationDisplay) {
	switch (locationDisplay) {
    case 'Charlotte':
      return 1;
    case 'Headquarters':
      return 2;
    case 'Birmingham':
      return 3;
    case 'Raleigh':
      return 4;
    case 'Austin':
      return 5;
    case 'Richmond':
      return 6;
    case 'Charleston':
      return 7;
    case 'Oklahoma City':
      return 8;
    case 'Virginia Beach':
      return 9;
    case 'San Antonio':
      return 10;
    case 'Dallas':
      return 11;
    case 'Indianapolis':
      return 12;
    case 'St. Louis':
      return 13;
    case 'Jacksonville':
      return 14;
    case 'Salt Lake City':
      return 15;
    case 'Columbus':
      return 16;
    case 'Cleveland':
      return 17;
    case 'Frisco':
      return 18;
    case 'Kansas City':
      return 19;
    case 'New Orleans':
      return 20;
    case 'Boca Raton':
      return 21;
    default:
      return '';
  }
}








// WEBPACK FOOTER //
// ./src/utils/formatting.jsx